import { render, staticRenderFns } from "./LodgingTabs.vue?vue&type=template&id=2a58b8dd"
import script from "./LodgingTabs.vue?vue&type=script&lang=js"
export * from "./LodgingTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports